<template>
  <div class="ui large modal zw transitionstyle" v-cloak>
    <div class="ui five top attached zw steps" v-cloak>
      <div class="step" v-for="(tab, index) in tabs" :key="index" @click="switchTab(index)"
           :class="{ 'active' : currentTab === index, 'disabled' : currentTab !== index && updateDisabled }"
           :id="tab.name">
        <i class="icon" :class="tab.icon"/>
        <div class="content">
          <div class="title">{{ tab.title }}</div>
          <div class="description">{{ tab.description }}</div>
        </div>
      </div>
    </div>

    <div class="ui active basic tab segment" v-if="tabs[currentTab].name === 'product' && tabExists('product')">
      <div class="content">
        <h3 class="ui header">
          {{ subscription.product.name }}
          <div class="ui sub header" v-html="subscription.product.intro"></div>
        </h3>
        <div class="ui divider"></div>
        <h4 class="ui header">{{ $t('modals.newsubscriptionmodal.product.content.description') }}</h4>
        <div class="description" v-html="subscription.product.description"></div>
      </div>
    </div>

    <div class="ui active basic tab segment" v-if="tabs[currentTab].name === 'accessories' && tabExists('accessories')">
      <div class="content">
        <div class="ui four stackable cards">
          <accessory v-for="accessory in subscription.product.accessories" :accessory="accessory" :water-meter="subscription.product.category.water_meter"
                     :addedAccessories="selectedAccessories" :changeable="true"
                     :deletable="subscription.status === 'deletable'" :key="accessory.id" @selected="selectAccessory"
                     @deselected="deselectAccessory"/>
        </div>
      </div>
    </div>

    <div class="ui active basic tab segment" v-show="tabs[currentTab].name === 'details'" v-if="tabExists('details')">
      <div class="content">
        <div class="ui header">{{ $t('modals.newsubscriptionmodal.details.content.header') }}</div>

        <p style="font-size: 16px;">{{ $t('modals.newsubscriptionmodal.details.content.transaction_date') }} - <b>{{ subscription.transaction_date }}</b>.</p>

        <div v-if="subscription.start_date > currentDate && subscription.transaction_date > currentDate">
          <span style="font-size: 16px; font-weight: 700;">
					  <i class="red info circle icon"/> {{ $t('modals.newsubscriptionmodal.details.content.activation_later') }} ({{ subscription.start_date }})
				  </span>
        </div>

        <template v-if="$store.getters.activeMerchant.kamstrup && subscription.product.category.water_meter">
          <div class="ui one cards" v-if="subscription.kamstrup_meters.length > 0">
            <div class="ui divider"></div>

            <div class="card">
              <div class="content">
                <div class="header" style="color: #f39c12;">Kamstrup</div>
                <p>{{ $t('pages.dashboard.details.kamstrup.headers.meter_data') }}</p>
                <div class="description">
                  <div class="info-piece">
                    <div class="info-label">From</div>
                    <div class="info-text">{{ meterReadingFrom }}</div>
                  </div>
                  <div class="info-piece">
                    <div class="info-label">To</div>
                    <div class="info-text">{{ meterReadingTo }}
                    </div>
                  </div>
                  <div class="info-piece">
                    <div class="info-label" style="color: #00a9f7;">{{ $t('pages.dashboard.details.kamstrup.total') }}</div>
                    <div class="info-text">{{ subscription.kamstrup_meters[0].meter_reading_total }} m3</div>
                  </div>
                  <template v-if="subscription.pricing_amount && parseFloat(subscription.pricing_amount) > 0">
                    <div class="info-piece">
                      <div class="info-label"></div>
                      <div class="info-text">{{ parseFloat(subscription.pricing_amount) }} DKK</div>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </template>

        <div class="ui divider"></div>

        <div class="ui form" :data-vv-scope="formScope">
          <div class="two fields" :key="index" v-for="(fields, index) in chunkProperty(subscription.product.fields, 2)">
            <field :field="field" :allowEdit="field.editable" :scope="formScope" :transparent="false" v-if="field"
                   :value="fieldValues" @input="changeFieldValue" v-for="field in fields" :key="field.id"></field>
          </div>
          <div class="field" :class="{ 'error' : errors.has(formScope + '.terms') }">
            <div class="ui checkbox" id="termsbox">
              <input name="terms" :data-vv-as="$t('modals.newsubscriptionmodal.details.terms')"
                     :checked="acceptingTerms" type="checkbox" @change="changeTermsValue()" :data-vv-scope="formScope"
                     v-validate="'required'">
              <label>{{ $t('modals.newsubscriptionmodal.details.agree_to') }} <a @click.prevent="showTermsModal = true">{{
                  $t('modals.newsubscriptionmodal.details.terms')
                }}</a></label>
              <span style="color: red;" v-if="errors.has(formScope + '.terms')">{{
                  errors.first(formScope + '.terms')
                }}</span>
            </div>
          </div>
        </div>
      </div>

      <semantic-modal v-model="showTermsModal"
                      :settings="{content_classes: {content: true}, closeable: false, closeable_button: false}">
        <div class="ui header" slot="header">
          {{ $t('modals.paymentterms.header') }}
        </div>
        <payment-terms/>
        <div class="actions" slot="actions">
          <div class="ui red button" @click="denyTerms()">{{ $t('globals.buttons.no') }}</div>
          <div class="ui ok green button" @click="acceptTerms()">{{ $t('globals.buttons.accept') }}</div>
        </div>
      </semantic-modal>
    </div>

    <div class="ui active basic tab segment" v-if="tabs[currentTab].name === 'payment' && tabExists('payment')">
      <div class="content">
        <h4 class="ui header">{{ $t('modals.newsubscriptionmodal.payment.content.header') }}</h4>
        <span v-if="subscription.charge" style="font-size: 16px; font-weight: 700;">
					<i class="blue info circle icon"/> {{ $t('modals.newsubscriptionmodal.payment.content.instant_payment') }}
				</span>
        <div class="ui divider"></div>

        <div class="ui zw three flex-center stackable cards">
          <payment-plan v-for="pricing in subscription.pricing_plans" @selectpayplan="selectPaymentplan"
                        @deselectpayplan="deselectPaymentplan" :pricing="pricing"
                        :active="selectedPaymentplan === pricing.option_id" :key="pricing.id"
                        :subscription="subscription"/>
        </div>
      </div>
    </div>

    <div class="ui active basic tab segment"
         v-if="tabs[currentTab].name === 'payment_method' && tabExists('payment_method') && !this.$store.getters.activeMerchant.free_subscription">
      <div class="content">
        <h4 class="ui header">{{ $t('modals.newsubscriptionmodal.payment_method.description') }}</h4>
        <p v-if="isDefaultPaymentMethod && filteredPaymentMethods.length > 0" class="text-info text-danger">
          * {{ $t('modals.newsubscriptionmodal.payment_method.default_payment_method') }}
        </p>
        <div class="ui divider"></div>
        <div class="ui zw two flex-center stackable cards">
          <template v-if="filteredPaymentMethods.length > 0">
            <payment-method v-for="paymentMethod in filteredPaymentMethods" :key="paymentMethod.id" :id="paymentMethod.id"
                            :name="paymentMethod.name" :slug="paymentMethod.slug" @select="selectPaymentMethod"
                            @deselect="deselectPaymentMethod" :active="selectedPaymentMethod === paymentMethod.slug"
                            :editable="!isDefaultPaymentMethod" :payment-plan="selectedPaymentType"/>
          </template>
          <template v-else>
            <b class="text-center" style="font-size: 20px; margin: 20px 0;">{{ $t('globals.validation.warning.not_all_steps_completed', {0: $t('globals.container.subscription')}) }}</b>
          </template>
        </div>
        <div class="ui divider notice"
             v-if="selectedPaymentplan && ((!subscription.product.category.water_meter && filteredPaymentMethods.length === 1 && selectedPaymentMethod === null) || selectedPaymentMethod === 'nets')">
          {{ $t('modals.nets_notice') }}
        </div>
        <div class="ui divider notice" v-if="selectedPaymentplan && selectedPaymentMethod === 'vipps'">
          <template v-if="vippsPaymentAllowed">
            <template v-if="selectedPaymentType === 'instant'">
              <template v-if="subscription.transaction_date > currentDate">
                {{ $t('modals.vipps_notice_later', {transaction_date: subscription.transaction_date}) }}
              </template>
              <template v-else>
                {{ $t('modals.vipps_notice') }}
              </template>
            </template>
            <template v-else>
              {{ $t('modals.vipps_notice_recurring') }}
            </template>
          </template>
          <template v-else>
            Unfortunately, Vipps payment method not allowed for this Subscription. Please contact the Merchant.
          </template>
        </div>
      </div>
    </div>

    <div class="actions" style="margin-bottom: 1rem;">
      <div class="ui red button" @click="cancelModal()">{{ $t('globals.buttons.cancel') }}</div>
      <div class="ui primary prev button" @click="prevTab()" v-if="showPrevious">{{
          $t('globals.buttons.previous')
        }}
      </div>
      <div class="ui primary zw next button" @click="nextTab()" v-if="showNext">{{ $t('globals.buttons.next') }}</div>
      <template v-else-if="!showNext">
        <div class="ui button green" @click="validateModal()"
             v-if="subscription.product.category.merchant.free_subscription"
             :class="[{ 'loading disabled' : buttonLoader }, { 'disabled' : disableActivateButton }]" id="subscribe">
          <span>{{ $t('globals.buttons.activate') }}</span>
        </div>
        <div class="ui button green" @click="validateModal()"
             v-else-if="subscription.start_date > currentDate && subscription.transaction_date > currentDate"
             :class="[{ 'loading disabled' : buttonLoader }, { 'disabled' : disableActivateButton }]" id="subscribe">
          <span>{{ $t('globals.buttons.finish') }}</span>
        </div>
        <vipps-mobilepay-button
          v-else-if="selectedPaymentMethod === 'vipps'"
          :class="{ 'disabled' : disableActivateButton }"
          :disabled="disableActivateButton"
          @click="validateModal()"
          type="button"
          brand="vipps"
          :language="getLanguage"
          variant="primary"
          rounded="false"
          verb="pay"
          :stretched="isMobile"
          branded="true"
          :loading="buttonLoader"></vipps-mobilepay-button>
        <div class="ui button green" @click="validateModal()" v-else
             :class="[{ 'loading disabled' : buttonLoader }, { 'disabled' : disableActivateButton }]" id="subscribe">
          <span>{{ $t('globals.buttons.finish') }}</span>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import chunk from 'lodash/chunk'
import size from 'lodash/size'
import find from 'lodash/find'
import findIndex from 'lodash/findIndex'
import hopscotch from 'hopscotch'

export default {
  name: 'NewSubscriptionModal',

  props: {
    active: {
      required: true,
      type: Boolean,
      default: false
    },

    subscription: {
      required: true
    },

    intro: {
      required: false,
      default: false,
      type: Boolean
    }
  },

  data () {
    return {
      showPrevious: false,
      showNext: true,
      updateDisabled: false,
      buttonLoader: false,
      formScope: 'detailsForm',
      currentDate: new Date().toISOString().split('T')[0],
      tabs: [
        {
          name: null,
          icon: null,
          title: null,
          description: null
        }
      ],
      currentTab: 0,
      disableNextButton: false,
      selectedAccessories: {},
      showTermsModal: false,
      acceptingTerms: false,
      fieldValues: [],
      selectedPaymentplan: null,
      selectedPaymentPrice: null,
      selectedPaymentType: null,
      selectedPaymentMethod: null,
      isDefaultPaymentMethod: false,
      paymentMethods: [
        {
          id: 1,
          name: 'Nets',
          slug: 'nets'
        },
        {
          id: 2,
          name: 'Vipps/MobilePay',
          slug: 'vipps'
        }
      ],
      filteredPaymentMethods: [],
      vippsPaymentAllowed: true,

      tour: {
        id: 'subscription-tour',
        steps: [],
        nextOnTargetClick: true,
        showNextButton: false,
        i18n: {
          nextBtn: this.$t('globals.buttons.next'),
          prevBtn: this.$t('globals.buttons.previous'),
          doneBtn: this.$t('globals.buttons.done'),
          skipBtn: this.$t('globals.buttons.skip')
        }
      }
    }
  },

  watch: {
    active () {
      this.selectedAccessories = this.subscription.accessories !== 'null' ? JSON.parse(this.subscription.accessories) : {}

      // checking for mandatory accessory storage amount. If enabled
      if (this.subscription.product.accessories.length > 0) {
        $.each(this.subscription.product.accessories, (index, item) => {
          if (item.mandatory) {
            if (item.apply_storage_count && item.storage_count_current <= 0) {
              this.updateDisabled = true

              this.$events.$emit('alert', {
                header: this.$t('globals.validation.errors.error'),
                message: this.$t('globals.accessories.no_accessory_left_full'),
                type: 'error',
                align: 'right'
              })

              return false
            }
          }
        })
      }

      this.selectedPaymentplan = this.subscription.option
      this.selectedPaymentType = this.subscription.pricing ? this.subscription.pricing.type : null
      this.isDefaultPaymentMethod = this.subscription.product.payment_method !== null
      this.selectedPaymentMethod = this.subscription.payment_method
      this.acceptingTerms = false

      if (this.isDefaultPaymentMethod) {
        this.selectedPaymentMethod = this.subscription.product.payment_method
        if (this.selectedPaymentMethod === 'vipps') {
          if (this.$store.getters.activeMerchant.kamstrup
            && (this.subscription.product.category.water_meter || this.subscription.product.unscheduled)
            && this.selectedPaymentType
            && this.selectedPaymentType !== 'instant'
          ) {
            this.selectedPaymentMethod = 'nets'
          }
        }

        const _this = this

        this.filteredPaymentMethods = this.paymentMethods.filter(function (currentValue) {
          if (currentValue.slug === _this.selectedPaymentMethod) {
            return currentValue
          }
        })
      }

      if (this.selectedPaymentType && !this.isDefaultPaymentMethod) {
        const _this = this

        this.filteredPaymentMethods = this.paymentMethods.filter(function (currentValue) {
          if (currentValue.slug === 'vipps') {
            if (!_this.$store.getters.activeMerchant.vipps) {
              return false
            }

            if (_this.$store.getters.activeMerchant.kamstrup
              && (_this.subscription.product.category.water_meter || _this.subscription.product.unscheduled)
              && _this.selectedPaymentType
              && _this.selectedPaymentType !== 'instant'
            ) {
              return false
            }

            let currentDate = new Date()
            const numberOfDaysToAdd = 2
            let result = currentDate.setDate(currentDate.getDate() + numberOfDaysToAdd)
            let vippsMinimumTransactionDate = new Date(result).toISOString().split('T')[0]

            if (_this.selectedPaymentType === 'recurring' && (_this.subscription.transaction_date <= _this.currentDate || _this.subscription.transaction_date > vippsMinimumTransactionDate)) {
              return currentValue
            } else if (_this.selectedPaymentType === 'instant') {
              return currentValue
            }
          } else {
            return currentValue
          }
        })
      }

      this.loadTabs()
        .then(filteredTabs => {
          this.tabs = filteredTabs
          $(this.$el).modal('refresh').modal('toggle') // show modal

          if (this.intro) {
            this.createIntro()
              .then(tour => {
                setTimeout(() => {
                  hopscotch.startTour(tour, 0)
                }, 300)
              })
          }
        })
    },

    showTermsModal () {
      if (this.intro) {
        hopscotch.endTour()
      }
    },

    currentTab () {
      $(window).trigger('resize')
      this.checkButtons()
    },

    subscription (newSubscription) {
      this.subscription = newSubscription
    }
  },

  mounted () {
    const _this = this
    // initialize modal
    this.$nextTick(function () {
      $(this.$el).modal({
        observeChanges: true,
        detachable: true,
        closable: false,
        closeable: false,
        transition: 'fade',

        dimmerSettings: {
          closable: false,
          closeable: false,
          useCSS: true
        },

        onVisible () {
          $(_this.$el).modal('refresh')
        },

        onHide () {
          if (_this.intro) {
            hopscotch.endTour([true])
          }
        }
      })
    })
  },

  methods: {
    changeFieldValue (field) {
      if (!find(this.fieldValues, {id: field.id})) {
        this.fieldValues.push(field)
      } else {
        let arrayValue = find(this.fieldValues, {id: field.id})
        arrayValue.value = field.value
      }
    },

    chunkProperty (chunkedProperty, value) {
      return chunk(chunkedProperty, value)
    },

    changeTermsValue () {
      this.acceptingTerms = !this.acceptingTerms
    },

    saveDetails (scope) {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll(scope)
          .then(result => {
            if (result) {
              this.postFields()
                .then(() => {
                  resolve(true)
                })
                .catch(() => {
                  reject(false)
                })
            } else {
              reject(false)
            }
          }).catch(() => {
          reject(false)
        })
      })
    },

    postFields () {
      return new Promise((resolve, reject) => {
        const fields = []

        $.map(this.fieldValues, function (item, index) {
          if (item.editable) {
            if (item.required) {
              if (item.value !== '') {
                fields.push({id: item.id, value: item.value})
              }
            } else {
              if (item.value === '') {
                fields.push({id: item.id, value: null})
              } else {
                fields.push({id: item.id, value: item.value})
              }
            }
          }
        })

        this.axios.put(`subscriptions/${this.subscription.id}`, {
          fields: fields
        })
          .then(response => {
            this.$emit('refreshsubscription', this.subscription.id)
            resolve(response)
          }).catch(error => {
          this.$events.$emit('alert', {
            header: this.$t('globals.validation.errors.error'),
            type: 'error',
            align: 'right'
          })
          reject(error)
        })
      })
    },

    updatePaymentMethod () {
      return new Promise((resolve, reject) => {
        this.axios.put(`subscriptions/${this.subscription.id}`, {
          payment_method: this.selectedPaymentMethod
        }).then(response => {
          this.$emit('refreshsubscription', this.subscription.id)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    updateAccessories () {
      return new Promise((resolve, reject) => {
        const accessories = []

        $.map(this.selectedAccessories, function (amount, accessoryId) {
          accessories.push(parseInt(accessoryId))
        })

        this.axios.put(`subscriptions/${this.subscription.id}`, {
          accessories: accessories
        })
          .then(response => {
            this.$emit('refreshsubscription', this.subscription.id)
            resolve(response)
          }).catch(error => {
          reject(error)
        })
      })
    },

    switchTab (nextTab) {
      // Validate fields and other things maybe?
      if (this.tabs[this.currentTab].name === 'details') {
        this.saveDetails(this.formScope)
          .then(() => {
            this.currentTab = nextTab

            if (this.intro) {
              hopscotch.startTour(this.tour, findIndex(this.tour.steps, {id: this.tabs[nextTab].name}))
            }
          }).catch(() => {
          if (nextTab === 0) {
            this.currentTab = nextTab

            if (this.intro) {
              hopscotch.startTour(this.tour, findIndex(this.tour.steps, {id: this.tabs[nextTab].name}))
            }
          }
        })
      } else if (this.tabs[this.currentTab].name === 'accessories') {
        this.updateAccessories()
          .then(() => {
            this.currentTab = nextTab

            if (this.intro) {
              hopscotch.startTour(this.tour, findIndex(this.tour.steps, {id: this.tabs[nextTab].name}))
            }
          }).catch((error) => {
          if (error.response.data.message) {
            this.$events.$emit('alert', {
              header: this.$t('globals.validation.errors.error'),
              message: error.response.data.message,
              type: 'error',
              align: 'right'
            })
          } else {
            this.$events.$emit('alert', {
              header: this.$t('globals.validation.errors.something_went_wrong'),
              message: this.$t('globals.validation.errors.try_again_later'),
              type: 'error',
              align: 'right'
            })
          }

          this.updateDisabled = true

          if (nextTab === 0) {
            this.currentTab = nextTab

            if (this.intro) {
              hopscotch.startTour(this.tour, findIndex(this.tour.steps, {id: this.tabs[nextTab].name}))
            }
          }
        })
      } else if (this.tabs[this.currentTab].name === 'payment') {
        if (this.tabExists('payment_method') && this.selectedPaymentType) {
          if (this.isDefaultPaymentMethod) {
            if (this.selectedPaymentMethod === 'vipps') {
              let currentDate = new Date()
              const numberOfDaysToAdd = 2
              let result = currentDate.setDate(currentDate.getDate() + numberOfDaysToAdd)
              let vippsMinimumTransactionDate = new Date(result).toISOString().split('T')[0]

              if (this.selectedPaymentType === 'recurring') {
                if (!(this.subscription.transaction_date <= this.currentDate || this.subscription.transaction_date > vippsMinimumTransactionDate)) {
                  this.vippsPaymentAllowed = false
                }
              } else {
                this.vippsPaymentAllowed = true
              }
            }
          } else {
            const _this = this

            this.filteredPaymentMethods = this.paymentMethods.filter(function (currentValue, index) {
              if (currentValue.slug === 'vipps' && _this.$store.getters.activeMerchant.vipps) {
                let currentDate = new Date()
                const numberOfDaysToAdd = 2
                let result = currentDate.setDate(currentDate.getDate() + numberOfDaysToAdd)
                let vippsMinimumTransactionDate = new Date(result).toISOString().split('T')[0]

                if (_this.selectedPaymentType === 'recurring' && (_this.subscription.transaction_date <= _this.currentDate || _this.subscription.transaction_date > vippsMinimumTransactionDate)) {
                  return currentValue
                } else if (_this.selectedPaymentType === 'instant') {
                  return currentValue
                }
              } else if (currentValue.slug === 'nets') {
                return currentValue
              }
            })
          }
        }

        this.currentTab = nextTab

        if (this.intro) {
          hopscotch.startTour(this.tour, findIndex(this.tour.steps, {id: this.tabs[nextTab].name}))
        }
      } else if (this.tabs[this.currentTab].name === 'payment_method') {
        if (nextTab < this.currentTab) {
          // Back button clicked
          if (!this.isDefaultPaymentMethod) {
            this.selectedPaymentMethod = null
          }
        }
        this.currentTab = nextTab

        if (this.intro) {
          hopscotch.startTour(this.tour, findIndex(this.tour.steps, {id: this.tabs[nextTab].name}))
        }
      } else {
        this.currentTab = nextTab

        if (this.intro) {
          hopscotch.startTour(this.tour, findIndex(this.tour.steps, {id: this.tabs[nextTab].name}))
        }
      }
    },

    nextTab () {
      const nextTab = this.currentTab + 1
      if (size(this.tabs[nextTab]) > 0) {
        this.switchTab(nextTab)
      }
    },

    prevTab () {
      const prevTab = this.currentTab - 1
      if (size(this.tabs[prevTab]) > 0) {
        this.switchTab(prevTab)
      }
    },

    tabExists (tabName) {
      return !!find(this.tabs, {name: tabName})
    },

    submitModal () {
      // validation and activation
      if (this.tabExists('details') && this.tabExists('payment') && this.tabExists('accessories')) {
        this.saveDetails(this.formScope)
          .then(() => {
            // refactor
            // Check if a paymentplan has been chosen
            if (this.selectedPaymentplan === null) {
              this.currentTab = findIndex(this.tabs, {name: 'payment'})
            } else {
              // show subscribe button loading
              this.buttonLoader = true
              this.updateAccessories()
                .then(() => {
                  this.axios.put(`subscriptions/${this.subscription.id}`, {
                    option_id: this.selectedPaymentplan
                  })
                    .then(() => {
                      // Create a method for this.. Activating a subscription.
                      this.activateSubscription(this.subscription.id)
                        .then(response => {
                          $(this.$el).modal('toggle')
                          this.$nextTick(() => {
                            setTimeout(() => {
                              this.buttonLoader = false
                            }, 550)
                          })
                        }).catch(() => {
                        this.$nextTick(() => {
                          setTimeout(() => {
                            this.buttonLoader = false
                          }, 550)
                        })
                      })
                    }).catch()
                }).catch()
            }
          }).catch(() => {
          // Goto details to fix errors
          this.currentTab = findIndex(this.tabs, {name: 'details'})
        })
      } else if (!this.tabExists('details') && this.tabExists('payment') && this.tabExists('accessories')) {
        if (this.selectedPaymentplan === null) {
          this.currentTab = findIndex(this.tabs, {name: 'payment'})
        } else {
          // show subscribe button loading
          this.buttonLoader = true
          this.updateAccessories()
            .then(() => {
              // attach payment plan
              this.axios.put(`subscriptions/${this.subscription.id}`, {
                option_id: this.selectedPaymentplan
              })
                .then(() => {
                  this.activateSubscription(this.subscription.id)
                    .then(response => {
                      this.$nextTick(() => {
                        setTimeout(() => {
                          this.buttonLoader = false
                        }, 550)
                      })
                      $(this.$el).modal('toggle')
                    }).catch(() => {
                    this.$nextTick(() => {
                      setTimeout(() => {
                        this.buttonLoader = false
                      }, 550)
                    })
                  })
                }).catch()
            })
        }
      } else if (!this.tabExists('details') && !this.tabExists('payment') && this.tabExists('accessories')) {
        this.buttonLoader = true
        this.updateAccessories()
          .then(() => {
            this.activateSubscription(this.subscription.id)
              .then(response => {
                this.$nextTick(() => {
                  setTimeout(() => {
                    this.buttonLoader = false
                  }, 550)
                })
                $(this.$el).modal('toggle')
              }).catch(() => {
              this.$nextTick(() => {
                setTimeout(() => {
                  this.buttonLoader = false
                }, 550)
              })
            })
          }).catch()
      } else if (this.tabExists('details') && this.tabExists('payment') && !this.tabExists('accessories')) {
        this.saveDetails(this.formScope)
          .then(() => {
            // refactor
            // Check if a paymentplan has been chosen
            if (this.selectedPaymentplan === null) {
              this.currentTab = findIndex(this.tabs, {name: 'payment'})
            } else {
              // show subscribe button loading
              this.buttonLoader = true
              // attach payment plan
              this.axios.put(`subscriptions/${this.subscription.id}`, {
                option_id: this.selectedPaymentplan
              })
                .then(() => {
                  // Create a method for this.. Activating a subscription.
                  this.activateSubscription(this.subscription.id)
                    .then(response => {
                      this.$nextTick(() => {
                        setTimeout(() => {
                          this.buttonLoader = false
                        }, 550)
                      })
                      $(this.$el).modal('toggle')
                    }).catch(() => {
                    this.$nextTick(() => {
                      setTimeout(() => {
                        this.buttonLoader = false
                      }, 550)
                    })
                  })
                }).catch()
            }
          }).catch(() => {
          // Goto details to fix errors
          this.currentTab = findIndex(this.tabs, {name: 'details'})
        })
      } else if (this.tabExists('details') && !this.tabExists('payment') && !this.tabExists('accessories')) {
        this.saveDetails(this.formScope)
          .then(() => {
            // show subscribe button loading
            this.buttonLoader = true
            // activate subscription
            this.activateSubscription(this.subscription.id)
              .then(response => {
                this.$nextTick(() => {
                  setTimeout(() => {
                    this.buttonLoader = false
                  }, 550)
                })
                $(this.$el).modal('toggle')
              }).catch(() => {
              this.$nextTick(() => {
                setTimeout(() => {
                  this.buttonLoader = false
                }, 550)
              })
            })
          }).catch(() => {
          // Goto details to fix errors
          this.currentTab = findIndex(this.tabs, {name: 'details'})
        })
      } else if (!this.tabExists('details') && this.tabExists('payment') && !this.tabExists('accessories')) {
        if (this.selectedPaymentplan === null) {
          this.currentTab = findIndex(this.tabs, {name: 'payment'})
        } else {
          // show subscribe button loading
          this.buttonLoader = true

          this.axios.put(`subscriptions/${this.subscription.id}`, {
            option_id: this.selectedPaymentplan
          })
            .then(() => {
              // Create a method for this.. Activating a subscription.
              this.activateSubscription(this.subscription.id)
                .then(response => {
                  this.$nextTick(() => {
                    setTimeout(() => {
                      this.buttonLoader = false
                    }, 550)
                  })
                  $(this.$el).modal('toggle')
                }).catch(() => {
                this.$nextTick(() => {
                  setTimeout(() => {
                    this.buttonLoader = false
                  }, 550)
                })
              })
            }).catch()
        }
      } else if (this.tabExists('details') && !this.tabExists('payment') && this.tabExists('accessories')) {
        this.saveDetails(this.formScope)
          .then(() => {
            // show subscribe button loading
            this.buttonLoader = true
            this.updateAccessories()
              .then(() => {
                this.axios.put(`subscriptions/${this.subscription.id}`, {
                  option_id: this.selectedPaymentplan
                })
                  .then(() => {
                    // Create a method for this.. Activating a subscription.
                    this.activateSubscription(this.subscription.id)
                      .then(response => {
                        this.$nextTick(() => {
                          setTimeout(() => {
                            this.buttonLoader = false
                          }, 550)
                        })
                        $(this.$el).modal('toggle')
                      }).catch(() => {
                      this.$nextTick(() => {
                        setTimeout(() => {
                          this.buttonLoader = false
                        }, 550)
                      })
                    })
                  }).catch()
              }).catch()
          }).catch(() => {
          // Goto details to fix errors
          this.currentTab = findIndex(this.tabs, {name: 'details'})
        })
      }
    },

    createVippsMobilePayPayment(unscheduled = false) {
      let data = {}

      if (this.intro) {
        data['intro'] = true
      }

      if (unscheduled) {
        data['unscheduled'] = true
      }

      this.axios.post(`subscriptions/${this.subscription.id}/createPayment`, data).then((response) => {
        if (response.status === 201) {
          if (response.data.status === 'agreement_exists') {
            this.$events.$emit('alert', {
              header: this.$t('globals.validation.success.success'),
              message: 'Vipps/MobilePay agreement is active. Activating subscription...',
              type: 'success',
              align: 'right'
            })
          } else if (response.data.status === 'instant_later') {
            this.$events.$emit('alert', {
              header: this.$t('globals.validation.success.success'),
              message: 'Subscription will be charged later. Activating...',
              type: 'success',
              align: 'right'
            })
          }

          this.activateSubscription(this.subscription.id)
        } else {
          let link = null

          if (response.data.payment_method === 'vipps') {
            link = response.data.url
          }

          $(this.$el).modal('toggle')

          if (link) {
            window.location.href = link
          } else {
            this.$events.$emit('alert', {
              header: this.$t('globals.validation.errors.something_went_wrong'),
              message: this.$t('globals.validation.errors.try_again_later'),
              type: 'error',
              align: 'right'
            })
          }
        }
      }).catch((error) => {
        // $(this.$el).modal('toggle')
        if (error.response) {
          if (error.response.data.message) {
            let messageText

            if (this.isJson(error.response.data.message)) {
              let errorDescription = JSON.parse(error.response.data.message);

              if (errorDescription.hasOwnProperty('error_description')) {
                messageText = errorDescription.error_description.message
              } else if (errorDescription.hasOwnProperty('message')) {
                messageText = errorDescription.message
              } else {
                messageText = this.$t('globals.validation.errors.try_again_later')
              }
            } else {
              messageText = error.response.data.message;
            }

            this.$events.$emit('alert', {
              header: this.$t('globals.validation.errors.error'),
              message: messageText,
              type: 'error',
              align: 'right'
            })
          } else {
            this.$events.$emit('alert', {
              header: this.$t('globals.validation.errors.something_went_wrong'),
              message: this.$t('globals.validation.errors.try_again_later'),
              type: 'error',
              align: 'right'
            })
          }
        } else {
          this.$events.$emit('alert', {
            header: this.$t('globals.validation.errors.something_went_wrong'),
            message: this.$t('globals.validation.errors.try_again_later'),
            type: 'error',
            align: 'right'
          })
        }
      })
    },

    validateModal() {
      this.saveDetails(this.formScope)
        .then(() => {
          // Check if a paymentplan has been chosen
          if (!this.subscription.product.category.water_meter && this.selectedPaymentplan === null) {
            this.currentTab = findIndex(this.tabs, {name: 'payment'})

            this.$events.$emit('alert', {
              header: this.$t('globals.validation.errors.error'),
              message: this.$t('modals.newsubscriptionmodal.validation.errors.no_interval_selected'),
              type: 'error',
              align: 'right'
            })
          } else if (this.acceptingTerms === true) {
            // show subscribe button loading
            this.buttonLoader = true
            this.updateAccessories()
              .then(() => {
                let data = {
                  option_id: this.selectedPaymentplan,
                  price: this.selectedPaymentPrice
                }

                if (this.selectedPaymentMethod === null) {
                  this.selectedPaymentMethod = 'nets'
                  data['payment_method'] = this.selectedPaymentMethod
                } else {
                  data['payment_method'] = this.selectedPaymentMethod
                }

                this.axios.put(`subscriptions/${this.subscription.id}`, data)
                  .then((response) => {
                    this.$nextTick(() => {
                      setTimeout(() => {
                        this.buttonLoader = false
                      }, 550)
                    })

                    if (response.data.kamstrup) {
                      if (this.selectedPaymentMethod === 'vipps') {
                        this.createVippsMobilePayPayment(true)
                      } else {
                        $(this.$el).modal('toggle')

                        let query = {
                          container: 'subscription',
                          unscheduled: true,
                        }

                        if (this.intro) {
                          query['intro'] = true
                        }

                        this.$router.push({
                          name: 'checkout',
                          params: {containerId: this.subscription.id},
                          query: query
                        })
                      }
                    } else {
                      if (this.subscription.product.category.merchant.free_subscription) {
                        this.activateSubscription(this.subscription.id)
                        $(this.$el).modal('toggle')
                      } else {
                        if (this.selectedPaymentMethod === 'nets') {
                          $(this.$el).modal('toggle')
                          let query = {
                            container: 'subscription',
                          }

                          if (this.intro) {
                            query['intro'] = true
                          }

                          this.$router.push({
                            name: 'checkout',
                            params: {containerId: this.subscription.id},
                            query: query
                          })
                        } else if (this.selectedPaymentMethod === 'vipps') {
                          this.createVippsMobilePayPayment()
                        }
                      }
                    }
                  }).catch((error) => {
                  if (error.response) {
                    this.$events.$emit('alert', {
                      header: this.$t('globals.validation.errors.error'),
                      message: error.response.data.message,
                      type: 'error',
                      align: 'right'
                    })
                  } else {
                    this.$events.$emit('alert', {
                      header: this.$t('globals.validation.errors.something_went_wrong'),
                      message: this.$t('globals.validation.errors.try_again_later'),
                      type: 'error',
                      align: 'right'
                    })
                  }
                  this.buttonLoader = false
                  this.currentTab = findIndex(this.tabs, {name: 'payment'})
                  this.deselectPaymentplan(this.selectedPaymentplan)
                })
              }).catch()
          } else {
            this.$events.$emit('alert', {
              header: this.$t('globals.validation.errors.error'),
              message: this.$t('modals.newsubscriptionmodal.validation.errors.not_accepting_terms'),
              type: 'error',
              align: 'right'
            })
            this.currentTab = findIndex(this.tabs, {name: 'details'})
          }
        }).catch(() => {
        // Goto details to fix errors
        this.currentTab = findIndex(this.tabs, {name: 'details'})
      })
    },

    cancelModal() {
      // refactor
      if (this.subscription.status === 'deletable') {
        this.axios.delete(`/subscriptions/${this.subscription.id}`)
          .then(() => {
            $(this.$el).modal('toggle')
            this.$events.$emit('subscription-cancelled', this.subscription.id)
          }).catch()
      } else {
        $(this.$el).modal('toggle')
        this.$events.$emit('subscription-closed', this.subscription.id)
      }
    },

    loadTabs () {
      return new Promise((resolve, reject) => {
        this.tabs = []
        this.currentTab = 0
        this.tabs.push(
          {
            name: 'product',
            icon: 'cube',
            title: this.$t('modals.newsubscriptionmodal.product.title'),
            description: this.$t('modals.newsubscriptionmodal.product.description')
          },
          {
            name: 'accessories',
            icon: 'shopping basket',
            title: this.$t('modals.newsubscriptionmodal.accessories.title'),
            description: this.$t('modals.newsubscriptionmodal.accessories.description')
          },
          {
            name: 'details',
            icon: 'info',
            title: this.$t('modals.newsubscriptionmodal.details.title'),
            description: this.$t('modals.newsubscriptionmodal.details.description')
          },
          {
            name: 'payment',
            icon: 'payment',
            title: this.$t('modals.newsubscriptionmodal.payment.title'),
            description: this.$t('modals.newsubscriptionmodal.payment.description')
          },
          {
            name: 'payment_method',
            icon: 'money',
            title: this.$t('modals.newsubscriptionmodal.payment_method.title'),
            description: this.$t('modals.newsubscriptionmodal.payment_method.description')
          }
        )
        const _this = this

        var filteredTabs = this.tabs.filter(function (currentValue, index) {
          if (currentValue.name === 'accessories') {
            if (!find(_this.subscription.product.accessories, {public: 1})) {
              if (_this.selectedAccessories) {
                let foundSomething = false
                $.map(_this.selectedAccessories, (index, accessoryId) => {
                  foundSomething = !!find(_this.subscription.product.accessories, {id: parseInt(accessoryId)})
                })

                if (foundSomething) {
                  return currentValue
                }
              }
            } else {
              return currentValue
            }
          } else if (currentValue.name === 'details') {
            // Always return the details since the user should always agree to terms and conditions.
            return currentValue
          } else if (currentValue.name === 'payment') {
            if (!_this.subscription.product.category.water_meter && (_this.subscription.pricing_plans !== null || _this.subscription.pricing_plans.length > 0)) {
              return currentValue
            }
          } else if (currentValue.name === 'payment_method') {
            if (_this.$store.getters.activeMerchant.vipps || (_this.$store.getters.activeMerchant.kamstrup && _this.subscription.product.category.water_meter)) {
              if (!_this.$store.getters.activeMerchant.free_subscription) {
                return currentValue
              }
            }
          } else if (currentValue.name === 'product') {
            return currentValue
          }
        })
        resolve(filteredTabs)
      })
    },

    checkButtons() {
      this.showNext = this.currentTab !== this.tabs.length - 1

      this.showPrevious = this.currentTab !== 0
    },

    selectAccessory(id) {
      this.selectedAccessories[id] = '1'
    },

    deselectAccessory(id) {
      delete this.selectedAccessories[id]

      if (size(this.selectedAccessories) <= 0 && !find(this.subscription.product.accessories, {public: 1})) {
        this.tabs.splice(findIndex(this.tabs, {name: 'accessories'}), 1)
        this.checkButtons()
      }
    },

    acceptTerms() {
      this.acceptingTerms = true
      $(this.$el).modal('toggle')
    },

    denyTerms() {
      this.acceptingTerms = false
      $(this.$el).modal('toggle')
    },

    selectPaymentplan(id, price, type) {
      // Live code
      this.selectedPaymentplan = id
      this.selectedPaymentPrice = price
      this.selectedPaymentType = type
    },

    deselectPaymentplan(id) {
      this.selectedPaymentplan = null
    },

    selectPaymentMethod(slug) {
      this.selectedPaymentMethod = slug
    },

    deselectPaymentMethod() {
      this.selectedPaymentMethod = null
    },

    activateSubscription(subscriptionId) {
      return new Promise((resolve, reject) => {
        this.axios.put(`subscriptions/${subscriptionId}/activate`)
          .then((response) => {
            if (response.data.hasOwnProperty('link')) {
              $(this.$el).modal('toggle')

              if (process.env.NODE_ENV === 'development') {
                this.$router.push({
                  name: 'mobile_pay_success',
                  query: {
                    id: subscriptionId,
                    type: 'subscriptions',
                    op: response.data.op
                  }
                })
              } else {
                window.location.href = response.data.link.href
              }
            } else {
              if (response.status === 201) {
                $(this.$el).modal('toggle')
                this.$events.$emit('updatesubscriptions', response.data, false)

                this.$events.$emit('alert', {
                  header: this.$t('globals.validation.warning.warning'),
                  message: this.$t('modals.newsubscriptionmodal.validation.nets.success.subscription_added_with_failed_charge'),
                  type: 'warning',
                  align: 'right'
                })
              } else {
                this.$events.$emit('alert', {
                  header: this.$t('globals.validation.success.success'),
                  message: this.$t('modals.newsubscriptionmodal.validation.nets.success.subscription_added'),
                  type: 'success',
                  align: 'right'
                })

                if (this.$store.getters.activeMerchant.free_subscription) {
                  setTimeout(() => window.location.reload(), 2000)
                }
              }

              setTimeout(() => {
                this.$router.push({name: 'subscriptiondashboard', params: {subscriptionId: response.data.id}},
                  () => {
                    this.$router.go()
                  }
                )
              }, 3000)

              if (this.intro) {
                hopscotch.endTour([true])
              }

              resolve(response.data)
            }
          }).catch(error => {
          if (error.response.data.message) {
            this.$events.$emit('alert', {
              header: this.$t('globals.validation.errors.error'),
              message: error.response.data.message,
              type: 'error',
              align: 'right'
            })
          }
          reject(error)
        })
      })
    },

    createIntro() {
      return new Promise((resolve, reject) => {
        this.tour.steps = []
        this.tour.steps.push(
          {
            title: this.$t('modals.newsubscriptionmodal.intro.firstsubscription.title'),
            content: this.$t('modals.newsubscriptionmodal.intro.firstsubscription.content'),
            target: '.ui.primary.zw.next.button',
            placement: 'top',
            xOffset: 'center',
            yOffset: '-20px',
            arrowOffset: 'center',
            delay: 300
          }
        )

        if (this.tabExists('product')) {
          this.tour.steps.push({
            id: 'product',
            title: this.$t('modals.newsubscriptionmodal.intro.productstab.title'),
            content: this.$t('modals.newsubscriptionmodal.intro.productstab.content'),
            target: 'product',
            placement: 'right',
            delay: 300
          })
        }

        if (this.tabExists('accessories')) {
          this.tour.steps.push({
            id: 'accessories',
            title: this.$t('modals.newsubscriptionmodal.intro.accessoriestab.title'),
            content: this.$t('modals.newsubscriptionmodal.intro.accessoriestab.content'),
            target: 'accessories',
            placement: 'right',
            delay: 300
          })
        }

        if (this.tabExists('details')) {
          this.tour.steps.push({
            id: 'details',
            title: this.$t('modals.newsubscriptionmodal.intro.detailstab.title'),
            content: this.$t('modals.newsubscriptionmodal.intro.detailstab.content'),
            target: 'details',
            placement: 'left',
            delay: 300
          })
        }

        if (this.tabExists('payment_method')) {
          let content = this.$t('modals.newsubscriptionmodal.intro.payment_method.content_vipps')

          this.tour.steps.push({
            id: 'payment_method',
            title: this.$t('modals.newsubscriptionmodal.intro.payment_method.title'),
            content: content,
            target: 'payment_method',
            placement: 'left',
            delay: 300
          })
        }

        if (this.tabExists('payment')) {
          this.tour.steps.push({
            id: 'payment',
            title: this.$t('modals.newsubscriptionmodal.intro.paymenttab.title'),
            content: this.$t('modals.newsubscriptionmodal.intro.paymenttab.content'),
            target: 'payment',
            placement: 'left',
            delay: 300
          })
        }

        resolve(this.tour)
      })
    },

    isJson(str) {
      try {
        JSON.parse(str);
      } catch (e) {
        return false;
      }
      return true;
    },
  },

  computed: {
    isMobile () {
      return window.innerWidth < 451
    },
    disableActivateButton () {
      if (this.selectedPaymentplan === null) {
        return true
      }

      if (this.selectedPaymentMethod === 'vipps' && !this.vippsPaymentAllowed) {
        return true
      }

      if (this.filteredPaymentMethods.length > 1 && this.selectedPaymentMethod === null) {
        return true
      }

      return false
    },

    getLanguage () {
      if (this.$root.$i18n.locale) {
        return this.$root.$i18n.locale
      } else {
        if (window.localStorage.language) {
          return window.localStorage.language
        } else if (navigator.language) {
          return navigator.language
        } else {
          return 'da'
        }
      }
    },

    meterReadingFrom() {
      if (this.subscription.kamstrup_meters[0].start_date) {
        return this.subscription.kamstrup_meters[0].start_date
      }

      return '-'
    },

    meterReadingTo() {
      if (this.subscription.kamstrup_meters[0].end_date) {
        return this.subscription.kamstrup_meters[0].end_date
      }

      return '-'
    },
  }
}
</script>

<style scoped>
.notice {
  padding-top: 20px;
  color: red !important;
  text-transform: none;
}
.text-danger {
  color: red;
}

@media only screen and (max-width: 768px) {
  .notice {
    padding-bottom: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/subscription/NewSubscriptionModal.vue